// extracted by mini-css-extract-plugin
export default {"tac":"tac_tac__BI4lG","card":"tac_card__QaW2V","txt":"tac_txt__dl1zh","btn":"tac_btn__rqYWY","hea":"tac_hea__e92UL","icon":"tac_icon__avr9L"};